import { render } from "./DraggableView.vue?vue&type=template&id=ba879ef4"
import script from "./DraggableView.vue?vue&type=script&lang=js"
export * from "./DraggableView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__